import clsx from "clsx";

import { unstable__Button as Button } from "@hagerty/react-components";

import { DialogV2, DialogButtonGroupV2 } from "../../../DialogV2";
import styles from "./UnsavedChangesDialog.module.scss";

type UnsavedChangesDialogProps = {
  heading: string;
  pending: boolean;
  closeDialog: () => void;
  onExit: () => void;
  onSave: () => Promise<void>;
};

export const UnsavedChangesDialog = ({
  heading,
  pending,
  closeDialog,
  onExit,
  onSave,
}: UnsavedChangesDialogProps) => {
  return (
    <DialogV2
      showCloseButton={!pending}
      heading={heading}
      message="Would you like to save your changes before you go?"
      onDismiss={() => {
        if (!pending) {
          closeDialog();
        }
      }}
    >
      <DialogButtonGroupV2>
        <Button
          onClick={() => {
            closeDialog();
            onExit();
          }}
          variant="outline"
          size="small"
          disabled={pending}
        >
          Discard and exit
        </Button>
        <Button
          className={clsx(
            styles.saveButton,
            pending ? "ap-loading-indicator" : ""
          )}
          autoFocus
          onClick={async () => {
            await onSave();
            closeDialog();
          }}
          variant="solid"
          size="small"
          disabled={pending}
        >
          Save
        </Button>
      </DialogButtonGroupV2>
    </DialogV2>
  );
};
